import http from "@seims/shared/src/services/HttpService";

var endpoint = `/lookup/`;
const eventEndPoint = `/lookup/event/`;
const partnerEndPoint = `/lookup/partnership/`;
const citizenScience = `/lookup/citizen/science/`;
const vsEndpoint = `/lookup/volunteer/scientist/`;

const getTitles = async () => {
  const response = await http.get(`${endpoint}titles`);
  return response;
};

const getRaces = async () => {
  const response = await http.get(`${endpoint}races?isEventRequest=true`);
  return response;
};

const getGenders = async () => {
  const response = await http.get(`${endpoint}genders`);
  return response;
};

const getProvinces = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces`);
  return response;
};

const getProgrammes = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguages = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getEventTypes = async () => {
  const response = await http.get(`${endpoint}event/venue/types`);
  return response;
};

const getEventGroups = async () => {
  const response = await http.get(`${endpoint}event/groups`);
  return response;
};

const getDisability = async () => {
  const response = await http.get(`${eventEndPoint}participant/disabilities`);
  return response;
};
const getFaqModule = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguges = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getProvincesDistrictTowns = async () => {
  const response = await http.get(
    `${endpoint}south-africa/province-district-towns`
  );
  return response;
};
const getParticipantTypes = async () => {
  const response = await http.get(`${eventEndPoint}participant/types`);
  return response;
};

const getLocalityTypes = async () => {
  const response = await http.get(`${partnerEndPoint}locality`);
  return response;
};

const getAgeGroup = async () => {
  const response = await http.get(`${eventEndPoint}participant/age-groups`);
  return response;
};

const getParticipantsMotivations = async () => {
  const response = await http.get(`${citizenScience}participant-motivations`);
  return response;
};

export const getQualifications = async () => {
  const { data } = await http.get(`${vsEndpoint}qualifications`);
  return data;
};

export const getOccupations = async () => {
  const { data } = await http.get(`${vsEndpoint}occupation`);
  return data;
};

// export const getEmploymentSectors = async () => {
//   const { data } = await http.get(`${endpoint}event/participant/sectors`);
//   return data;
// };

export const getEmploymentSectors = async () => {
  const { data } = await http.get(`${vsEndpoint}employment-sector`);
  return data;
};

export const getVolunteerRoles = async () => {
  const { data } = await http.get(`${vsEndpoint}roles`);
  return data;
};

export const getVolunteerMotivations = async () => {
  const { data } = await http.get(`${vsEndpoint}motivations`);
  return data;
};

export const getEmploymentStatus = async () => {
  const { data } = await http.get(`${vsEndpoint}employment-status`);
  return data;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTitles,
  getRaces,
  getGenders,
  getDisability,
  getProvinces,
  getEventTypes,
  getEventGroups,
  getAgeGroup,
  getLanguges,
  getFaqModule,
  getProvincesDistrictTowns,
  getParticipantTypes,
  getLocalityTypes,
  getParticipantsMotivations,
  getVolunteerRoles,
  getVolunteerMotivations,
  getEmploymentSectors,
  getEmploymentStatus
};
